import { apiClient, extractData } from '../../lib/api-client.js';

// ---- DEPRECATED: manual "Generate Report" flow ----
// Superseded by the automatic weekly report below (see fetchCurrentReport)
// — unused now that the "Generate Report" button is gone. Kept in case
// manual generation is re-enabled later, rather than deleted.

/** @deprecated Part of the deprecated manual report flow (see the note above). */
export type ReportPeriod = 'weekly' | 'monthly' | 'quarterly';
/** @deprecated Part of the deprecated manual report flow (see the note above). */
export type JobStatus = 'pending' | 'processing' | 'ready' | 'failed';

/** @deprecated Part of the deprecated manual report flow (see the note above). */
export interface ReportJobResponse {
  jobId: string;
  status: JobStatus;
  reportText?: string;
}

/** @deprecated Part of the deprecated manual report flow (see the note above). */
export async function requestReport(period: ReportPeriod): Promise<ReportJobResponse> {
  const res = await apiClient.post('/v1/reports', { period });
  return extractData<ReportJobResponse>(res);
}

/** @deprecated Part of the deprecated manual report flow (see the note above). */
export async function pollReport(jobId: string): Promise<ReportJobResponse> {
  const res = await apiClient.get(`/v1/reports/${jobId}`);
  return extractData<ReportJobResponse>(res);
}

export type CurrentReportStatus = 'none' | 'pending' | 'processing' | 'ready' | 'failed';

export interface CurrentReportResponse {
  status: CurrentReportStatus;
  reportText?: string;
}

/** The automatic weekly report for the user's most recently completed week. */
export async function fetchCurrentReport(): Promise<CurrentReportResponse> {
  const res = await apiClient.get('/v1/reports/current');
  return extractData<CurrentReportResponse>(res);
}
